import React from "react";

import Table from "components/Table";
import { orderVersionsColumns } from "./columns";

interface IProps {
  isLoading: boolean;
  loadData: () => void;
  data: any[];
}

class OrderVersions extends React.PureComponent<IProps> {
  public componentDidMount() {
    this.props.loadData();
  }

  public render() {
    const { data, isLoading } = this.props;

    return (
      <Table
        columns={orderVersionsColumns}
        dataSource={data}
        isLoading={isLoading}
      />
    );
  }
}

export default OrderVersions;
